var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7857_25331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.02319 11L3.6875 15L8.02319 19V16H15.6405V14H8.02319V11ZM23.247 9L18.9113 5V8H11.294V10H18.9113V13L23.247 9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7857_25331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0793,
    height: 24,
    fill: "white",
    transform: "translate(0.425781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapLight);
export default __webpack_public_path__ + "static/media/swapLight.144c89751d7be0f9b581cc15dd9a6ea2.svg";
export { ForwardRef as ReactComponent };